module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon10.1e175d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon10.png
// module id = o9qp
// module chunks = 0